// extracted by mini-css-extract-plugin
module.exports = {"container":"doc-set-module--container--3Q8xV"};